export const LOAD_EXTENSION = 'LOAD_EXTENSION';
export const LOAD_EXTENSION_ERROR = 'LOAD_EXTENSION_ERROR';
export const LOAD_EXTENSION_SUCCESS = 'LOAD_EXTENSION_SUCCESS';



// WEBPACK FOOTER //
// ./src/app/extensions/constants.js